import { useMemo } from 'react';
import { HealthPlanYear } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';

import { DEFAULT_DATE_FORMAT } from '@/common/constants.ts';

import { useGetHealthPlanYearsQuery } from '../queries';

const useGetHealthPlanYears = (id?: string) => {
  const { data, isLoading } = useGetHealthPlanYearsQuery(id);

  const healthPlanYearOptions = useMemo(() => {
    if (!data) return [];

    return data?.map((year) => ({
      key: _.toString(year.id),
      value: _.toString(year.id),
      title: year.name || '',
    }));
  }, [data]);

  const formattedData: HealthPlanYear[] = useMemo(() => {
    if (!data) {
      return [];
    }
    return data?.map((year) => ({
      id: _.toString(year.id),
      healthPlanId: '',
      name: year.name || '',
      validFrom: year.valid_from || '',
      validTo: year.valid_to || dayjs(new Date()).format(DEFAULT_DATE_FORMAT),
    }));
  }, [data]);

  const currentHealthPlanYear = useMemo(() => {
    const currentDate = dayjs();
    const selectedYear = formattedData.find((year: HealthPlanYear) => {
      const validFrom = dayjs(year.validFrom);
      const validTo = year.validTo ? dayjs(year.validTo) : currentDate;

      return currentDate.isAfter(validFrom) && currentDate.isBefore(validTo.add(1, 'day'));
    });

    return selectedYear || formattedData?.[0];
  }, [formattedData]);

  return {
    healthPlanYearOptions,
    currentHealthPlanYear,
    formattedData,
    isLoading,
  };
};

export default useGetHealthPlanYears;
